import React, { useEffect, useRef } from "react";
import Map from "@arcgis/core/Map";
import SceneView from "@arcgis/core/views/SceneView";
import GeoJSONLayer from "@arcgis/core/layers/GeoJSONLayer";

export default function TestMapping3() {
  const mapDiv = useRef(null);

  useEffect(() => {
    if (!mapDiv.current) return;

    // Load your GeoJSON
    const geojsonLayer = new GeoJSONLayer({
      url: "/iusevolutione/assets/geojson/nagkaisang_nayon.geojson", // adjust path
      renderer: {
        type: "simple",
        symbol: {
          type: "polygon-3d",
          symbolLayers: [
            {
              type: "extrude",
              material: { color: "#4CAF50" }, // green
              edges: { type: "solid", color: "#333" }
            }
          ]
        },
        visualVariables: [
          {
            type: "size",
            field: "building:levels", // use attribute if available
            valueUnit: "meters"
          }
        ]
      }
    });

    const map = new Map({
      basemap: "streets",
      ground: "world-elevation",
      layers: [geojsonLayer]
    });

    const view = new SceneView({
      container: mapDiv.current,
      map: map,
      camera: {
        position: {
          longitude: 121.0568, // adjust to your barangay
          latitude: 14.6760,
          z: 500 // altitude (meters)
        },
        tilt: 65
      }
    });

    return () => view?.destroy();
  }, []);

  return <div style={{ height: "100vh", width: "100%" }} ref={mapDiv}></div>;
}


// eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY2xxeTBib3pyMGsxcTJpbXQ3bmo4YXU0ZiJ9.wvqlBMQSxTHgvAh6l9OXXw
